var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApplicationReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16716",
    fill: "none",
    stroke: "#1f76b3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12569",
    d: "M19 6.94h-6.471a1 1 0 01-.829-.44l-1.4-2.063A1 1 0 009.471 4H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V8.94a2 2 0 00-2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12570",
    d: "M14.889 12.056l-3.611 3.611L9.111 13.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12571",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgApplicationReview;


//////////////////
// WEBPACK FOOTER
// ./src/icons/applicationReview.svg
// module id = 820
// module chunks = 101